var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 36,
    viewBox: "0 0 25 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1559,
    cy: 7.01299,
    r: 7.01299,
    fill: "#89C33F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.9871C0 22.7901 5.02372 17.7664 11.2208 17.7664H13.0909C19.288 17.7664 24.3117 22.7901 24.3117 28.9871V36.0001H0V28.9871Z",
    fill: "#89C33F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonGreen);
export default __webpack_public_path__ + "static/media/person-green.5d659a9e0a8ab30fbf1ec1edf3565099.svg";
export { ForwardRef as ReactComponent };